import React from 'react'
import { Col, DatePicker, Form, Input, InputNumber } from 'antd'
import { get } from 'lodash'
import { dateVal } from '../../../../modules/Utils'

import { compose } from 'recompose'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { DepartmentsApi } from '../../../../api/Projects/Resources'
import withData from '../../../../elements/Select/withData'

const { TextArea } = Input
const TypeSelect = compose(
  withSelectFetch({
    dropdown: 'clientBudgets',
    name: 'type',
  }),
  withSpinning,
  withSort
)(CustomSelect)
const CategorySelect = compose(
  withSelectFetch({
    dropdown: 'clientBudgets',
    name: 'category',
  }),
  withSpinning,
  withSort
)(CustomSelect)

function ClientBudgetForm(props) {
  const { getFieldDecorator } = props.form
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14, offset: 1 },
    },
  }
  const { clientBudget, project } = props
  const { list: departments, fetching: fetchingDepartments } = useFetchList(() =>
    DepartmentsApi.list(project._id, 'departments')
  )
  const DepartmentsSelect = compose(
    withSpinning,
    withData({
      data: departments,
    })
  )(CustomSelect)

  return (
    <Form>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Serial">
          {getFieldDecorator('serial', {
            initialValue: get(clientBudget, 'serial'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('name', {
            initialValue: get(clientBudget, 'name'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Department">
          {getFieldDecorator('department._id', {
            initialValue: get(clientBudget, 'department._id'),
          })(<DepartmentsSelect fetching={fetchingDepartments} keyAtr={'_id'} valueAtr={'name'} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Description">
          {getFieldDecorator('description', {
            initialValue: get(clientBudget, 'description'),
          })(<TextArea />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Start date">
          {getFieldDecorator('date.start', {
            initialValue: dateVal(clientBudget, 'date.start'),
          })(<DatePicker style={{ width: '100%' }} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="End date">
          {getFieldDecorator('date.end', {
            initialValue: dateVal(clientBudget, 'date.end'),
          })(<DatePicker style={{ width: '100%' }} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Type">
          {getFieldDecorator('type', {
            initialValue: get(clientBudget, 'type'),
          })(<TypeSelect />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Category">
          {getFieldDecorator('category', {
            initialValue: get(clientBudget, 'category'),
          })(<CategorySelect />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Reference No">
          {getFieldDecorator('reference.no', {
            initialValue: get(clientBudget, 'reference.no'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Amount">
          {getFieldDecorator('amount', {
            initialValue: get(clientBudget, 'amount'),
          })(<InputNumber />)}
        </Form.Item>
      </Col>
    </Form>
  )
}

ClientBudgetForm.propTypes = {}
ClientBudgetForm.defaultProps = {}

export default Form.create()((ClientBudgetForm))
